<template>
  <div class="wrong-analysis-mobile">
    <!-- 操作按钮区域，固定在右下角 -->
    <div class="mobile-action-buttons">
      <!-- 查询按钮 -->
      <el-button class="mobile-icon-btn" @click="showFilterDialog">
        <i class="el-icon-search"></i>
      </el-button>
      
      <!-- 统计按钮 -->
      <el-button class="mobile-icon-btn" @click="showStatisticsDialog">
        <i class="el-icon-data-analysis"></i>
      </el-button>
    </div>

    <!-- PC端提示说明 -->
    <div class="pc-tip">
      <i class="el-icon-monitor"></i>
      <span>在 PC 端上查看数据效果更佳。</span>
    </div>



    <!-- 桑基图区域 -->
    <el-card class="chart-card" v-loading="chartLoading" :body-style="{ padding: '6px' }">
      <div slot="header" class="card-header">
        <span>{{ chartType ? '时间-难度-错误类型' : '标签-难度-错误类型' }} 流向分析</span>
      </div>
      
      <!-- 移动端控制按钮区域 -->
      <div class="mobile-controls-section">
        <div class="mobile-control-group">
          <span class="control-label">时间</span>
          <el-switch
            v-model="chartType"
            @change="handleChartTypeChange">
          </el-switch>
        </div>
        <div class="mobile-control-group">
          <span class="control-label">排序</span>
          <el-switch
            v-model="sortEnabled"
            @change="handleSortToggle">
          </el-switch>
        </div>
        <div class="mobile-control-group">
          <span class="control-label">字符</span>
          <el-switch
            v-model="showLabels"
            @change="handleLabelToggle">
          </el-switch>
        </div>
      </div>
      
      <div class="chart-content">
        <div class="chart-container" ref="sankeyChart" :style="{ height: chartHeight + 'px' }"></div>
      </div>
    </el-card>

    <!-- 查询条件弹窗 -->
    <div class="dialog-container" v-show="filterDialogVisible">
      <div class="dialog-mask" @click="filterDialogVisible = false"></div>
      <div class="custom-dialog" style="top: 10vh;">
        <div class="dialog-close" @click="filterDialogVisible = false">×</div>
        <div class="dialog-body filter-dialog-body">
          <div class="dialog-content filter-dialog-content" style="background-color: #ffffff;">
            <h3 class="dialog-custom-title filter-title">查询条件</h3>
            <el-form :model="queryForm" class="filter-form" size="small" label-width="80px">
              <el-form-item label="题目标签">
                <el-select
                  v-model="queryForm.tagNames"
                  multiple
                  filterable
                  placeholder="请选择题目标签"
                  style="width: 100%">
                  <el-option
                    v-for="tag in tagOptions"
                    :key="tag.value"
                    :label="tag.label"
                    :value="tag.value">
                  </el-option>
                </el-select>
              </el-form-item>
              
              <el-form-item label="题目难度">
                <el-select
                  v-model="queryForm.questionLevels"
                  multiple
                  filterable
                  placeholder="请选择题目难度"
                  style="width: 100%">
                  <el-option
                    v-for="level in levelOptions"
                    :key="level.value"
                    :label="level.label"
                    :value="level.value">
                    <span :style="{ 
                      display: 'inline-block',
                      width: '10px',
                      height: '10px',
                      borderRadius: '2px',
                      marginRight: '6px',
                      backgroundColor: getDifficultyColor(level.value)
                    }"></span>
                    {{ level.label }}
                  </el-option>
                </el-select>
              </el-form-item>
              
              <el-form-item label="错误类型">
                <el-select
                  v-model="queryForm.errorNames"
                  multiple
                  filterable
                  placeholder="请选择错误类型"
                  style="width: 100%">
                  <el-option
                    v-for="error in errorOptions"
                    :key="error.value"
                    :label="error.label"
                    :value="error.value">
                  </el-option>
                </el-select>
              </el-form-item>
              
              <el-form-item label="比赛日期">
                <div class="date-range-container">
                  <el-date-picker
                    v-model="queryForm.start_date"
                    type="date"
                    placeholder="开始日期"
                    value-format="yyyy-MM-dd"
                    size="small"
                    style="width: 100%;"
                    class="date-picker-item">
                  </el-date-picker>
                  <span class="date-separator">至</span>
                  <el-date-picker
                    v-model="queryForm.end_date"
                    type="date"
                    placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    size="small"
                    style="width: 100%;"
                    class="date-picker-item">
                  </el-date-picker>
                </div>
              </el-form-item>
            </el-form>
            <div class="dialog-footer filter-footer">
              <el-button size="small" @click="handleReset">重置</el-button>
              <el-button size="small" type="primary" @click="handleSearch">查询</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 统计数据弹窗 -->
    <div class="dialog-container" v-show="statisticsDialogVisible">
      <div class="dialog-mask" @click="statisticsDialogVisible = false"></div>
      <div class="custom-dialog stats-dialog" style="top: 10vh;">
        <div class="dialog-close" @click="statisticsDialogVisible = false">×</div>
        <div class="dialog-body statistics-dialog-body">
          <div class="dialog-content" style="background-color: #ffffff;">
            <h3 class="dialog-custom-title">统计数据</h3>
            <div class="mobile-statistics-grid">
              <div class="stat-item">
                <div class="stat-value">{{ statisticsData.totalWrongCount || 0 }}</div>
                <div class="stat-label">
                  <i class="el-icon-warning-outline"></i>
                  总错题数
                </div>
              </div>
              
              <div class="stat-item">
                <div class="stat-value">{{ statisticsData.involvedTags || 0 }}</div>
                <div class="stat-label">
                  <i class="el-icon-collection-tag"></i>
                  涉及标签
                </div>
              </div>
              
              <div class="stat-item">
                <div class="stat-value">{{ statisticsData.mainErrorType || '-' }}</div>
                <div class="stat-label">
                  <i class="el-icon-warning-outline"></i>
                  主要错误
                </div>
              </div>
              
              <div class="stat-item">
                <div class="stat-value">{{ statisticsData.mostWrongTag1 || '-' }}</div>
                <div class="stat-label">
                  <i class="el-icon-star-off"></i>
                  常错标签-1
                </div>
              </div>
              
              <div class="stat-item">
                <div class="stat-value">{{ statisticsData.mostWrongTag2 || '-' }}</div>
                <div class="stat-label">
                  <i class="el-icon-star-off"></i>
                  常错标签-2
                </div>
              </div>
              
              <div class="stat-item">
                <div class="stat-value">{{ statisticsData.mostWrongTag3 || '-' }}</div>
                <div class="stat-label">
                  <i class="el-icon-star-off"></i>
                  常错标签-3
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import request from '@/utils/request'

export default {
  name: 'WrongAnalysisMobile',
  data() {
    return {
      loading: false,
      chartLoading: false,
      chartHeight: 400,
      chartType: false, // false: 标签维度, true: 时间维度
      sortEnabled: false, // true: 启用排序(layoutIterations: 0), false: 自动布局(layoutIterations: 32)
      showLabels: true, // true: 显示节点标签, false: 隐藏标签(点击时显示)
      
      // 查询表单
      queryForm: {
        tagNames: [],
        questionLevels: [],
        errorNames: [],
        dateRange: [],
        start_date: '',
        end_date: ''
      },
      
      // 下拉选项数据
      tagOptions: [],
      levelOptions: [],
      errorOptions: [],
      
      // 图表实例
      sankeyChart: null,
      
      // 桑基图数据
      sankeyData: {
        nodes: [],
        links: [],
        completePaths: []
      },
      
      // 点击状态管理
      clickedNode: null,
      isClickHighlighted: false,
      
      // 弹窗控制
      filterDialogVisible: false,
      statisticsDialogVisible: false,
      
      // 统计数据
      statisticsData: {
        totalWrongCount: 0,
        involvedTags: 0,
        mainErrorType: '-',
        mostWrongTag1: '-',
        mostWrongTag2: '-',
        mostWrongTag3: '-'
      },
      
    }
  },
  computed: {
    // 动态计算图表高度 - 移动端时间维度紧凑优化
    dynamicChartHeight() {
      const nodeCount = this.sankeyData.nodes.length
      const baseHeight = 400
      
      // 如果是时间维度，使用更紧凑的高度计算
      let minHeightPerNode = 28
      if (this.chartType) {
        minHeightPerNode = 20  // 时间维度使用更小的空间
      }
      
      const calculatedHeight = Math.max(baseHeight, nodeCount * minHeightPerNode + 150)
      
      // 移动端设置合理的最大高度限制
      return Math.min(calculatedHeight, 1000)
    }
  },
  watch: {
    dynamicChartHeight(newHeight) {
      this.chartHeight = newHeight
      this.$nextTick(() => {
        if (this.sankeyChart) {
          this.sankeyChart.resize()
        }
      })
    }
  },
  mounted() {
    this.initChart()
    this.loadOptions()
    this.handleQuery()
    
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('orientationchange', this.handleResize)
  },
  beforeDestroy() {
    if (this.sankeyChart) {
      this.sankeyChart.dispose()
    }
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('orientationchange', this.handleResize)
  },
  methods: {
    // 去掉节点名称的前缀
    removeNodePrefix(nodeName) {
      if (!nodeName) return nodeName
      return nodeName.replace(/^(时间_|标签_|难度_|错误_|状态_)/, '')
    },
    
    // 初始化图表
    initChart() {
      if (this.sankeyChart) {
        this.sankeyChart.dispose()
      }
      
      this.sankeyChart = echarts.init(this.$refs.sankeyChart)
      this.updateChart()
    },
    
    // 更新图表
    updateChart() {
      if (!this.sankeyChart) return
      
      const option = {
        tooltip: {
          trigger: 'item',
          triggerOn: 'mousemove',
          formatter: function(params) {
            if (params.dataType === 'edge') {
              const sourceName = params.data.source.replace(/^(时间_|标签_|难度_|错误_)/, '')
              const targetName = params.data.target.replace(/^(时间_|标签_|难度_|错误_)/, '')
              // 判断目标节点是否为AC节点
              const isAC = params.data.target === '错误_AC' || targetName === 'AC'
              const label = isAC ? '题目数量' : '错题数量'
              return `${sourceName} → ${targetName}<br/>${label}: ${params.data.value}`
            } else {
              const nodeName = params.data.name.replace(/^(时间_|标签_|难度_|错误_)/, '')
              // 判断是否为AC节点（第三层节点）
              const isAC = params.data.name === '错误_AC' || (params.data.category === 2 && nodeName === 'AC')
              const label = isAC ? '题目数量' : '错题数量'
              return `${nodeName}<br/>${label}: ${params.data.value || 0}`
            }
          },
          backgroundColor: 'rgba(50, 50, 50, 0.9)',
          borderColor: '#333',
          textStyle: {
            color: '#fff',
            fontSize: 11
          }
        },
        series: [
          {
            type: 'sankey',
            layout: 'none',
            emphasis: {
              focus: 'adjacency',
              blurScope: 'coordinateSystem',
              itemStyle: {
                shadowBlur: 8,
                shadowColor: 'rgba(0,0,0,0.4)',
                borderWidth: 2,
                borderColor: '#333'
              },
              lineStyle: {
                opacity: 1,
                width: 5
              },
              label: {
                color: '#000',
                fontWeight: 'bold',
                fontSize: 11
              }
            },
            blur: {
              itemStyle: {
                opacity: 0.15  // 大幅降低非高亮区域的透明度
              },
              lineStyle: {
                opacity: 0.1   // 大幅降低非高亮连线的透明度
              },
              label: {
                opacity: 0.3   // 降低非高亮标签的透明度
              }
            },
            select: {
              itemStyle: {
                borderColor: '#333'
              }
            },
            nodeAlign: 'justify', // 恢复到justify
            nodeGap: this.calculateNodeGap(), // 动态计算节点间距
            nodeWidth: this.calculateNodeWidth(), // 动态计算节点宽度
            draggable: false, // 移动端禁用拖拽
            focusNodeAdjacency: 'allEdges',
            layoutIterations: this.sortEnabled ? 0 : 32, // 根据排序开关控制布局迭代次数
            data: this.sankeyData.nodes.map(node => ({
              ...node,
              label: {
                show: this.showLabels, // 根据开关控制标签显示
                position: node.category === 2 ? 'left' : 'right', // 第三层(错误类型)在左侧，其他在右侧
                formatter: (params) => {
                  return this.removeNodePrefix(params.name)
                },
                fontSize: 10,
                color: '#333'
              }
            })),
            links: this.sankeyData.links,
            lineStyle: {
              color: 'gradient',
              curveness: 0.5,
              opacity: 0.7
            },
            itemStyle: {
              borderWidth: 1,
              borderColor: '#fff',
              shadowBlur: 1,
              shadowColor: 'rgba(0,0,0,0.1)'
            },
            // 移动端添加适中的布局 - 为居中效果留出空间
            left: '1%',
            right: '1%',
            top: '2%',
            bottom: '2%'
          }
        ]
      }
      
      this.sankeyChart.setOption(option, true)
      
      // 移动端现在显示节点标签
      // setTimeout(() => {
      //   this.forceHideLabels()
      // }, 100)
      
      
      // 添加触摸和点击事件处理（移动端）
      this.sankeyChart.off('mouseover')
      this.sankeyChart.off('mouseout') 
      this.sankeyChart.off('click')
      
      // 移动端主要使用点击交互
      this.sankeyChart.on('click', (params) => {
        if (params.dataType === 'node') {
          if (this.clickedNode === params.data.name) {
            // 如果点击的是已选中的节点，则取消高亮
            this.clearClickHighlight()
          } else {
            // 否则高亮新节点
            this.clickedNode = params.data.name
            this.isClickHighlighted = true
            this.highlightNodePath(params.data.name)
          }
        } else if (params.dataType === 'edge') {
          const edgeKey = `${params.data.source}-${params.data.target}`
          if (this.clickedNode === edgeKey) {
            this.clearClickHighlight()
          } else {
            this.clickedNode = edgeKey
            this.isClickHighlighted = true
            this.highlightEdgePath(params.data)
          }
        }
      })
      
      // 点击空白区域取消高亮
      this.sankeyChart.getZr().on('click', (params) => {
        if (!params.target) {
          this.clearClickHighlight()
        }
      })
    },
    
    // 加载下拉选项数据
    async loadOptions() {
      try {
        const response = await request({
          url: '/api/wrong-analysis/options',
          method: 'get'
        })
        
        if (response.code === 200) {
          const data = response.data
          
          // 处理标签选项
          this.tagOptions = data.tags.map(tag => ({
            value: tag,
            label: tag
          }))
          
          // 处理难度选项
          this.levelOptions = data.levels.map(level => ({
            value: level,
            label: level
          }))
          
          // 处理错误类型选项
          this.errorOptions = data.errors.map(error => ({
            value: error,
            label: error
          }))
        }
      } catch (error) {
        console.error('加载选项数据失败:', error)
      }
    },
    
    // 查询数据
    async handleQuery() {
      this.loading = true
      this.chartLoading = true
      
      try {
        const params = {}
        
        // 处理数组参数，添加[]后缀
        if (this.queryForm.tagNames && this.queryForm.tagNames.length > 0) {
          params['tagNames[]'] = this.queryForm.tagNames
        }
        if (this.queryForm.questionLevels && this.queryForm.questionLevels.length > 0) {
          params['questionLevels[]'] = this.queryForm.questionLevels
        }
        if (this.queryForm.errorNames && this.queryForm.errorNames.length > 0) {
          params['errorNames[]'] = this.queryForm.errorNames
        }
        if (this.queryForm.dateRange && this.queryForm.dateRange.length > 0) {
          params['dateRange[]'] = this.queryForm.dateRange
        }
        
        params.chartType = this.chartType ? 'time' : 'tag'
        
        const response = await request({
          url: '/api/wrong-analysis/data',
          method: 'get',
          params
        })
        
        if (response.code === 200) {
          const data = response.data
          
          // 更新桑基图数据
          const sankeyData = data.sankeyData || { nodes: [], links: [], completePaths: [] }
          
          // 对所有节点进行排序优化
          if (sankeyData.nodes.length > 0) {
            if (this.chartType) {
              sankeyData.nodes = this.sortTimeNodes(sankeyData.nodes)
            } else {
              sankeyData.nodes = this.sortTagNodes(sankeyData.nodes)
            }
            sankeyData.nodes = this.sortAllLayerNodes(sankeyData.nodes)
          }
          
          this.sankeyData = {
            nodes: sankeyData.nodes,
            links: sankeyData.links,
            completePaths: sankeyData.completePaths
          }
          
          // 更新统计数据
          this.statisticsData = data.statistics || {}
          
          // 更新图表
          this.updateChart()
        } else {
          this.$message.error(response.message || '获取数据失败')
        }
      } catch (error) {
        console.error('查询数据失败:', error)
        this.$message.error('查询失败，请稍后重试')
      } finally {
        this.loading = false
        this.chartLoading = false
      }
    },
    
    // 重置查询条件
    handleReset() {
      this.queryForm = {
        tagNames: [],
        questionLevels: [],
        errorNames: [],
        dateRange: [],
        start_date: '',
        end_date: ''
      }
    },
    
    // 处理查询（弹窗中的查询）
    handleSearch() {
      // 将开始日期和结束日期转换为dateRange数组格式
      if (this.queryForm.start_date || this.queryForm.end_date) {
        this.queryForm.dateRange = [
          this.queryForm.start_date || '',
          this.queryForm.end_date || ''
        ]
      } else {
        this.queryForm.dateRange = []
      }
      
      this.handleQuery()
      this.filterDialogVisible = false
    },
    
    // 显示查询弹窗
    showFilterDialog() {
      this.filterDialogVisible = !this.filterDialogVisible
    },
    
    // 显示统计信息弹窗
    showStatisticsDialog() {
      this.statisticsDialogVisible = !this.statisticsDialogVisible
    },
    
    // 切换图表类型
    handleChartTypeChange() {
      this.handleQuery()
    },
    
    // 切换排序模式
    handleSortToggle() {
      this.updateChart()
    },
    
    // 切换标签显示
    handleLabelToggle() {
      // 如果从隐藏切换到显示，需要清除当前的高亮状态
      if (this.showLabels && this.isClickHighlighted) {
        this.clearClickHighlight()
      }
      this.updateChart()
    },
    
    // 获取难度颜色
    getDifficultyColor(level) {
      const colorMap = {
        '红题': '#F56C6C',
        '橙题': '#E6A23C', 
        '黄题': '#F7BA2A',
        '绿题': '#67C23A',
        '蓝题': '#409EFF',
        '紫题': '#8E44AD',
        '黑题': '#2C3E50',
        '未定义': '#909399'
      }
      return colorMap[level] || '#909399'
    },
    
    
    // 窗口大小变化处理
    handleResize() {
      setTimeout(() => {
        if (this.sankeyChart) {
          this.sankeyChart.resize()
        }
      }, 100)
    },
    
    // 动态计算节点间距（移动端版本）- 时间维度紧凑优化
    calculateNodeGap() {
      const nodeCount = this.sankeyData.nodes.length
      const layer1Count = this.sankeyData.nodes.filter(n => n.category === 0).length
      const availableHeight = this.chartHeight - 120
      
      // 如果是时间维度，使用更紧凑的间距
      if (this.chartType) {
        if (layer1Count <= 4) {
          return 20 // 时间节点少时使用适中间距
        } else if (layer1Count <= 6) {
          return 16 // 减少间距
        } else if (layer1Count <= 8) {
          return 14 // 进一步减少
        } else if (layer1Count <= 12) {
          return 12 // 时间节点多时使用小间距
        } else {
          // 时间节点很多时，使用最小间距
          const minGap = 10 // 移动端时间维度的最小间距
          const calculatedGap = Math.floor(availableHeight / layer1Count * 0.35)
          return Math.max(minGap, calculatedGap)
        }
      } else {
        // 标签维度使用原有逻辑
        if (nodeCount <= 6) {
          return 30
        } else if (nodeCount <= 12) {
          return 22
        } else if (nodeCount <= 20) {
          return 16
        } else if (nodeCount <= 35) {
          return 10
        } else {
          const minGap = 8
          const calculatedGap = Math.floor(availableHeight / nodeCount * 0.35)
          return Math.max(minGap, calculatedGap)
        }
      }
    },
    
    // 动态计算节点宽度（移动端版本）
    calculateNodeWidth() {
      const nodeCount = this.sankeyData.nodes.length
      
      if (nodeCount <= 8) {
        return 16
      } else if (nodeCount <= 15) {
        return 14
      } else if (nodeCount <= 30) {
        return 12
      } else {
        return 10 // 移动端节点很多时使用更小宽度
      }
    },
    
    // 高亮节点的完整路径（移动端版本）
    highlightNodePath(nodeName) {
      const relatedNodes = new Set()
      const relatedLinks = new Set()
      
      // 添加当前节点
      relatedNodes.add(nodeName)
      
      // 根据节点类型确定查找策略
      const nodeCategory = this.getNodeCategory(nodeName)
      
      if (nodeCategory === 0) {
        // 第一层节点（标签/时间）-> 查找完整的数据流路径
        this.findCompleteDataPaths(nodeName, relatedNodes, relatedLinks)
      } else if (nodeCategory === 1) {
        // 第二层节点（难度）-> 查找通过该难度的完整路径
        this.findPathsThroughMiddleNode(nodeName, relatedNodes, relatedLinks)
      } else if (nodeCategory === 2) {
        // 第三层节点（错误类型）-> 查找导致该错误的完整路径
        this.findPathsToEndNode(nodeName, relatedNodes, relatedLinks)
      }
      
      // 更新图表，高亮相关元素
      this.updateHighlight(relatedNodes, relatedLinks)
    },
    
    // 高亮边的相关路径（移动端版本）
    highlightEdgePath(edgeData) {
      const relatedNodes = new Set()
      const relatedLinks = new Set()
      
      // 添加边的源和目标节点
      relatedNodes.add(edgeData.source)
      relatedNodes.add(edgeData.target)
      relatedLinks.add(`${edgeData.source}-${edgeData.target}`)
      
      // 查找同时经过源节点和目标节点的完整路径（AND逻辑）
      this.findPathsThroughSpecificEdge(edgeData.source, edgeData.target, relatedNodes, relatedLinks)
      
      // 更新图表
      this.updateHighlight(relatedNodes, relatedLinks)
    },
    
    // 获取节点分类（移动端版本）
    getNodeCategory(nodeName) {
      const node = this.sankeyData.nodes.find(n => n.name === nodeName)
      return node ? node.category : -1
    },
    
    // 向前查找路径（从当前节点到后续节点）
    findForwardPaths(nodeName, relatedNodes, relatedLinks) {
      this.sankeyData.links.forEach(link => {
        if (link.source === nodeName) {
          relatedNodes.add(link.target)
          relatedLinks.add(`${link.source}-${link.target}`)
          // 递归查找下一层
          this.findForwardPaths(link.target, relatedNodes, relatedLinks)
        }
      })
    },
    
    // 向后查找路径（从当前节点到前置节点）
    findBackwardPaths(nodeName, relatedNodes, relatedLinks) {
      this.sankeyData.links.forEach(link => {
        if (link.target === nodeName) {
          relatedNodes.add(link.source)
          relatedLinks.add(`${link.source}-${link.target}`)
          // 递归查找上一层
          this.findBackwardPaths(link.source, relatedNodes, relatedLinks)
        }
      })
    },
    
    // 查找完整的数据流路径（专用于第一层节点）- 使用真实路径数据
    findCompleteDataPaths(startNodeName, relatedNodes, relatedLinks) {
      const relatedPaths = this.sankeyData.completePaths.filter(path => 
        path.layer1 === startNodeName
      )
      
      relatedPaths.forEach(path => {
        path.path.forEach(node => {
          relatedNodes.add(node)
        })
        
        for (let i = 0; i < path.path.length - 1; i++) {
          relatedLinks.add(`${path.path[i]}-${path.path[i + 1]}`)
        }
      })
    },
    
    // 查找通过中间节点（难度）的完整路径
    findPathsThroughMiddleNode(middleNodeName, relatedNodes, relatedLinks) {
      const relatedPaths = this.sankeyData.completePaths.filter(path => 
        path.layer2 === middleNodeName
      )
      
      relatedPaths.forEach(path => {
        path.path.forEach(node => {
          relatedNodes.add(node)
        })
        
        for (let i = 0; i < path.path.length - 1; i++) {
          relatedLinks.add(`${path.path[i]}-${path.path[i + 1]}`)
        }
      })
    },
    
    // 查找导致末端节点（错误类型）的完整路径
    findPathsToEndNode(endNodeName, relatedNodes, relatedLinks) {
      const relatedPaths = this.sankeyData.completePaths.filter(path => 
        path.layer3 === endNodeName
      )
      
      relatedPaths.forEach(path => {
        path.path.forEach(node => {
          relatedNodes.add(node)
        })
        
        for (let i = 0; i < path.path.length - 1; i++) {
          relatedLinks.add(`${path.path[i]}-${path.path[i + 1]}`)
        }
      })
    },
    
    // 查找同时经过特定边（源节点->目标节点）的完整路径（移动端版本）
    findPathsThroughSpecificEdge(sourceNodeName, targetNodeName, relatedNodes, relatedLinks) {
      // 使用completePaths数据查找同时包含源节点和目标节点的路径
      const relatedPaths = this.sankeyData.completePaths.filter(path => {
        // 检查路径中是否包含源节点和目标节点，并且它们是相邻的
        const pathNodes = path.path
        for (let i = 0; i < pathNodes.length - 1; i++) {
          if (pathNodes[i] === sourceNodeName && pathNodes[i + 1] === targetNodeName) {
            return true
          }
        }
        return false
      })
      
      // 添加所有相关路径中的节点和连接
      relatedPaths.forEach(path => {
        // 添加路径中的所有节点
        path.path.forEach(node => {
          relatedNodes.add(node)
        })
        
        // 添加路径中的所有连接
        for (let i = 0; i < path.path.length - 1; i++) {
          relatedLinks.add(`${path.path[i]}-${path.path[i + 1]}`)
        }
      })
    },
    
    // 更新高亮效果（移动端版本）
    updateHighlight(relatedNodes, relatedLinks) {
      const option = this.sankeyChart.getOption()
      const series = option.series[0]
      
      // 处理节点高亮 - 更强的对比度（移动端）
      series.data = this.sankeyData.nodes.map(node => ({
        ...node,
        itemStyle: {
          ...node.itemStyle,
          opacity: relatedNodes.has(node.name) ? 1 : 0.15,  // 更低的非高亮透明度
          shadowBlur: relatedNodes.has(node.name) ? 6 : 0,
          shadowColor: relatedNodes.has(node.name) ? 'rgba(0,0,0,0.3)' : 'transparent'
        },
        label: {
          show: this.showLabels || relatedNodes.has(node.name), // 显示开关开启时显示所有，关闭时只显示高亮节点
          position: node.category === 2 ? 'left' : 'right', // 保持第三层在左侧
          formatter: (params) => {
            return this.removeNodePrefix(params.name)
          },
          fontSize: 10,
          color: relatedNodes.has(node.name) ? '#000' : '#999',
          fontWeight: relatedNodes.has(node.name) ? 'bold' : 'normal',
          opacity: relatedNodes.has(node.name) ? 1 : 0.3
        }
      }))
      
      // 处理连线高亮 - 更强的对比度（移动端）
      series.links = this.sankeyData.links.map(link => ({
        ...link,
        lineStyle: {
          opacity: relatedLinks.has(`${link.source}-${link.target}`) ? 0.9 : 0.1,  // 更低的非高亮透明度
          color: 'gradient',
          width: relatedLinks.has(`${link.source}-${link.target}`) ? 4 : undefined
        }
      }))
      
      this.sankeyChart.setOption(option)
    },
    
    // 清除高亮效果（移动端版本）
    clearHighlight() {
      const option = this.sankeyChart.getOption()
      const series = option.series[0]
      
      // 恢复所有节点的正常状态
      series.data = this.sankeyData.nodes.map(node => ({
        ...node,
        itemStyle: {
          ...node.itemStyle,
          opacity: 1
        },
        label: {
          show: this.showLabels, // 根据开关状态恢复标签显示
          position: node.category === 2 ? 'left' : 'right', // 保持第三层在左侧
          formatter: (params) => {
            return this.removeNodePrefix(params.name)
          },
          fontSize: 10,
          color: '#333'
        }
      }))
      
      // 恢复所有连线的正常状态
      series.links = this.sankeyData.links.map(link => ({
        ...link,
        lineStyle: {
          opacity: 0.7,
          color: 'gradient'
        }
      }))
      
      this.sankeyChart.setOption(option)
    },
    
    // 清除点击高亮（移动端版本）
    clearClickHighlight() {
      this.clickedNode = null
      this.isClickHighlighted = false
      this.clearHighlight()
    },
    
    // 判断是否需要显示tooltip（移动端版本）
    needsTooltip(text) {
      if (!text || text === '-') return false
      return text.length > 8 // 移动端超过8个字符显示tooltip
    },
    
    // 对时间节点进行重新排序（移动端版本）
    sortTimeNodes(nodes) {
      const timeNodes = []
      const otherNodes = []
      
      // 分离时间节点和其他节点
      nodes.forEach(node => {
        if (node.name && node.name.startsWith('时间_')) {
          timeNodes.push(node)
        } else {
          otherNodes.push(node)
        }
      })
      
      // 对时间节点按时间降序排序
      timeNodes.sort((a, b) => {
        const timeA = a.name.replace('时间_', '')
        const timeB = b.name.replace('时间_', '')
        
        try {
          const [yearA, monthA] = timeA.split('/').map(x => parseInt(x))
          const [yearB, monthB] = timeB.split('/').map(x => parseInt(x))
          
          if (yearA !== yearB) {
            return yearB - yearA // 年份降序
          }
          return monthB - monthA // 月份降序
        } catch {
          return timeB.localeCompare(timeA)
        }
      })
      
      // 重新设置y坐标
      timeNodes.forEach((node, index) => {
        node.y = index / Math.max(1, timeNodes.length - 1)
        node.localY = node.y
      })
      
      return [...timeNodes, ...otherNodes]
    },
    
    // 对标签节点进行排序（移动端版本）
    sortTagNodes(nodes) {
      const tagNodes = []
      const otherNodes = []
      
      // 分离标签节点和其他节点
      nodes.forEach(node => {
        if (node.name && node.name.startsWith('标签_')) {
          tagNodes.push(node)
        } else {
          otherNodes.push(node)
        }
      })
      
      // 对标签节点按名称排序
      tagNodes.sort((a, b) => {
        const tagA = a.name.replace('标签_', '').toLowerCase()
        const tagB = b.name.replace('标签_', '').toLowerCase()
        return tagA.localeCompare(tagB)
      })
      
      return [...tagNodes, ...otherNodes]
    },
    
    // 对所有层级节点进行综合排序和位置优化（移动端版本）
    sortAllLayerNodes(nodes) {
      const layer1Nodes = []  // 第一层（时间/标签）
      const layer2Nodes = []  // 第二层（难度）
      const layer3Nodes = []  // 第三层（错误类型）
      
      // 按类别分组
      nodes.forEach(node => {
        if (node.category === 0) {
          layer1Nodes.push(node)
        } else if (node.category === 1) {
          layer2Nodes.push(node)
        } else if (node.category === 2) {
          layer3Nodes.push(node)
        }
      })
      
      // 第一层排序
      if (this.chartType) {
        // 时间维度：按时间降序
        layer1Nodes.sort((a, b) => {
          const timeA = a.name.replace('时间_', '')
          const timeB = b.name.replace('时间_', '')
          try {
            const [yearA, monthA] = timeA.split('/').map(x => parseInt(x))
            const [yearB, monthB] = timeB.split('/').map(x => parseInt(x))
            if (yearA !== yearB) return yearB - yearA
            return monthB - monthA
          } catch {
            return timeB.localeCompare(timeA)
          }
        })
      } else {
        // 标签维度：按名称字母顺序
        layer1Nodes.sort((a, b) => {
          const tagA = a.name.replace('标签_', '').toLowerCase()
          const tagB = b.name.replace('标签_', '').toLowerCase()
          return tagA.localeCompare(tagB)
        })
      }
      
      // 第二层（难度）按标准顺序排序
      const difficultyOrder = ['红题', '橙题', '黄题', '绿题', '蓝题', '紫题', '黑题', '未定义']
      layer2Nodes.sort((a, b) => {
        const levelA = a.name.replace('难度_', '')
        const levelB = b.name.replace('难度_', '')
        const indexA = difficultyOrder.indexOf(levelA)
        const indexB = difficultyOrder.indexOf(levelB)
        return (indexA === -1 ? 99 : indexA) - (indexB === -1 ? 99 : indexB)
      })
      
      // 第三层（错误类型）按重要性排序 - 完整的10种错误类型
      const errorOrder = [
        '1-算法未掌握', 
        '2-思路/逻辑偏差', 
        '3-实现/细节错误', 
        '4-效率/复杂度问题', 
        '5-边界/特殊情况遗漏',
        '6-题意理解偏差',
        '7-工具/环境问题',
        '8-心理性错误',
        '9-其他/暂未分类错误',
        '未定义'
      ]
      layer3Nodes.sort((a, b) => {
        const errorA = a.name.replace('错误_', '')
        const errorB = b.name.replace('错误_', '')
        const indexA = errorOrder.indexOf(errorA)
        const indexB = errorOrder.indexOf(errorB)
        return (indexA === -1 ? 99 : indexA) - (indexB === -1 ? 99 : indexB)
      })
      
      // 重新计算位置，实现防遮盖和居中（移动端版本）
      this.redistributeNodePositions(layer1Nodes, layer2Nodes, layer3Nodes)
      
      return [...layer1Nodes, ...layer2Nodes, ...layer3Nodes]
    },
    
    // 强制隐藏节点标签
    forceHideLabels() {
      if (!this.sankeyChart) return
      
      const option = this.sankeyChart.getOption()
      if (option.series && option.series[0]) {
        // 强制设置所有节点的标签为不显示
        option.series[0].label = {
          show: false,
          formatter: () => '',
          position: 'inside',
          fontSize: 0
        }
        
        // 如果有节点数据，逐个设置标签
        if (option.series[0].data) {
          option.series[0].data = option.series[0].data.map(node => ({
            ...node,
            label: {
              show: false,
              formatter: () => '',
              fontSize: 0
            }
          }))
        }
        
        this.sankeyChart.setOption(option, true)
      }
    },
    
    // 重新分配节点位置 - 恢复到简单的居中方案
    redistributeNodePositions(layer1Nodes, layer2Nodes, layer3Nodes) {
      // 如果禁用排序模式，不设置任何位置，让ECharts完全自动布局
      if (!this.sortEnabled) {
        return
      }
      // 第一层：占用整个高度，均匀分布
      layer1Nodes.forEach((node, index) => {
        if (layer1Nodes.length > 1) {
          node.y = index / (layer1Nodes.length - 1)
        } else {
          node.y = 0.5
        }
      })
      
      // 第二层：居中分布
      if (layer2Nodes.length > 0) {
        const centerOffset = 0.18  // 上下各留18%
        const availableHeight = 0.64 // 中间64%可用
        
        layer2Nodes.forEach((node, index) => {
          if (layer2Nodes.length > 1) {
            const relativePos = index / (layer2Nodes.length - 1)
            node.y = centerOffset + relativePos * availableHeight
          } else {
            node.y = 0.5
          }
        })
      }
      
      // 第三层：居中分布
      if (layer3Nodes.length > 0) {
        const centerOffset = 0.12  // 上下各留12%
        const availableHeight = 0.76 // 中间76%可用
        
        layer3Nodes.forEach((node, index) => {
          if (layer3Nodes.length > 1) {
            const relativePos = index / (layer3Nodes.length - 1)
            node.y = centerOffset + relativePos * availableHeight
          } else {
            node.y = 0.5
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.wrong-analysis-mobile {
  padding: 8px;
  background-color: #f5f5f5;
}

/* PC端提示说明 */
.pc-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  margin-bottom: 12px;
  background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%);
  border: 1px solid #e1f5fe;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  
  i {
    font-size: 16px;
    color: #2196f3;
    margin-right: 6px;
  }
  
  span {
    font-size: 12px;
    color: #37474f;
    font-weight: 500;
  }
}

.card-header {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
}

/* 移动端控制区域样式 */
.mobile-controls-section {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 12px 8px 8px; /* 减少左右padding以适应三个按钮 */
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 1px solid #e1e8ed;
  margin: -6px -6px 0 -6px; /* 抵消card的padding */
}

.mobile-control-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.control-label {
  font-size: 12px;
  font-weight: 500;
  color: #495057;
  text-align: center;
  min-width: 32px;
}

.mobile-control-group .el-switch {
  transform: scale(0.85); /* 稍微缩小开关尺寸 */
}

/* 响应式优化 - 超小屏幕 */
@media (max-width: 360px) {
  .mobile-controls-section {
    padding: 10px 4px 6px; /* 进一步减少padding */
  }
  
  .control-label {
    font-size: 10px; /* 更小的字体 */
    min-width: 24px; /* 更小的最小宽度 */
  }
  
  .mobile-control-group .el-switch {
    transform: scale(0.7); /* 更小的开关 */
  }
  
  .mobile-control-group {
    gap: 4px; /* 更小的间距 */
  }
}



.chart-card {
  border-radius: 8px;
}

.chart-content {
  padding: 0;
}

.chart-container {
  width: 100%;
  min-height: 400px;
}


/* Element UI 组件样式调整 */
.wrong-analysis-mobile :deep(.el-card__header) {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
}

.wrong-analysis-mobile :deep(.el-card__body) {
  padding: 12px 16px;
}

.wrong-analysis-mobile :deep(.el-select) {
  width: 100%;
}

.wrong-analysis-mobile :deep(.el-date-editor) {
  width: 100%;
}

.wrong-analysis-mobile :deep(.el-button--small) {
  padding: 8px 16px;
  font-size: 12px;
}

.wrong-analysis-mobile :deep(.el-switch__label) {
  font-size: 12px;
}

/* 移动端操作按钮 - 参考GameMobile.vue */
.mobile-action-buttons {
  position: fixed;
  right: 15px;
  bottom: 135px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  z-index: 2001;
  width: 40px;
  align-items: center;
  padding: 0 !important;
  margin: 0 !important;
  
  .el-button {
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box !important;
  }
}

.mobile-icon-btn {
  width: 40px !important;
  height: 40px !important;
  border-radius: 40px !important;
  background-color: rgba(255, 255, 255, 0.5) !important;
  color: #409eff !important;
  border: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  padding: 0 !important;
  margin: 0 !important;
  transition: all 0.3s ease !important;
  position: relative !important;
  left: 0 !important;
  
  i {
    font-size: 20px !important;
    margin: 0 !important;
    padding: 0 !important;
    display: inline-flex !important;
    justify-content: center !important;
    align-items: center !important;
    width: 20px !important;
    height: 20px !important;
  }
  
  &:hover, &:focus {
    background-color: rgba(255, 255, 255, 0.8) !important;
    transform: scale(1.05) !important;
  }
  
  &:active {
    background-color: rgba(255, 255, 255, 0.9) !important;
    transform: scale(0.95) !important;
  }
}

/* 弹窗样式 - 参考GameMobile.vue */
.dialog-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
  display: flex;
  justify-content: center;
}

.dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 2001;
}

.custom-dialog {
  position: absolute;
  z-index: 2002;
  width: 95%;
  max-height: 80vh;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.custom-dialog.stats-dialog {
  height: auto;
  max-height: none;
  width: 92%;
  max-width: 520px;
}

.dialog-close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.1);
  color: #909399;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
  z-index: 10;
}

.dialog-body {
  padding: 20px;
  max-height: 80vh;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  
  &::-webkit-scrollbar {
    display: none;
  }
  
  &.filter-dialog-body {
    padding: 15px 15px 10px;
  }
  
  &.statistics-dialog-body {
    max-height: none;
    overflow-y: visible;
    padding: 12px 10px;
  }
}

.dialog-content {
  padding: 5px;
  background-color: #ffffff !important;
  
  .dialog-custom-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin: 0 0 15px 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    text-align: center;
  }
  
  .dialog-footer {
    text-align: right;
    margin-top: 15px;
    padding-top: 10px;
    border-bottom: 1px solid #ebeef5;
  }
}

.filter-dialog-content {
  padding: 0;
  
  .filter-title {
    font-size: 16px;
    margin: 0 0 10px 0;
    padding-bottom: 8px;
  }
}

.filter-form {
  .el-form-item {
    margin-bottom: 10px;
    
    .el-form-item__label {
      padding-right: 5px;
      line-height: 32px;
    }
    
    .el-form-item__content {
      line-height: 32px;
    }
  }
}

.filter-footer {
  margin-top: 10px;
  padding-top: 8px;
  
  .el-button {
    padding: 7px 15px;
  }
}

/* 移动端统计网格 - 参考GameMobile.vue */
.mobile-statistics-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  padding: 2px 0;
  max-height: none;
  overflow-y: visible;
  
  .stat-item {
    background-color: #f9fafc;
    border-radius: 8px;
    padding: 8px 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    min-height: 65px;
    height: auto;
    
    &:active {
      transform: scale(0.98);
    }
    
    /* 给不同卡片添加渐变背景色 - 参考GameMobile.vue */
    &:nth-child(1) {
      background: linear-gradient(to top, 
        rgba(226, 206, 186, 0.3) 0%, 
        rgba(226, 206, 186, 1) 100%);
      .stat-label, i { color: #8D7B64; }
      .stat-value { color: #6D5B44; }
    }
    &:nth-child(2) {
      background: linear-gradient(to top, 
        rgba(209, 178, 164, 0.3) 0%, 
        rgba(209, 178, 164, 1) 100%);
      .stat-label, i { color: #956B5A; }
      .stat-value { color: #754B3A; }
    }
    &:nth-child(3) {
      background: linear-gradient(to top, 
        rgba(190, 206, 185, 0.3) 0%, 
        rgba(190, 206, 185, 1) 100%);
      .stat-label, i { color: #5B7155; }
      .stat-value { color: #3B5135; }
    }
    &:nth-child(4) {
      background: linear-gradient(to top, 
        rgba(199, 188, 205, 0.3) 0%, 
        rgba(199, 188, 205, 1) 100%);
      .stat-label, i { color: #6B5873; }
      .stat-value { color: #4B3853; }
    }
    &:nth-child(5) {
      background: linear-gradient(to top, 
        rgba(187, 199, 214, 0.3) 0%, 
        rgba(187, 199, 214, 1) 100%);
      .stat-label, i { color: #4A5F78; }
      .stat-value { color: #2A3F58; }
    }
    &:nth-child(6) {
      background: linear-gradient(to top, 
        rgba(220, 198, 170, 0.3) 0%, 
        rgba(220, 198, 170, 1) 100%);
      .stat-label, i { color: #8B7447; }
      .stat-value { color: #6B5427; }
    }
    
    .stat-value {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 5px;
      text-align: center;
      line-height: 1.2;
    }
    
    .stat-label {
      font-size: 11px;
      display: flex;
      align-items: center;
      justify-content: center;
      
      i {
        margin-right: 3px;
        font-size: 13px;
      }
    }
  }
}

/* 日期选择器优化样式 */
.date-range-container {
  display: flex;
  align-items: center;
  gap: 2px;  /* 减少间距 */
  width: 100%;

  .date-picker-item {
    flex: 1;
    
    ::v-deep .el-input__inner {
      font-size: 12px !important;
      padding-left: 25px !important;
      padding-right: 5px !important;
    }
    
    ::v-deep .el-input__prefix {
      left: 3px !important;
    }
    
    ::v-deep .el-input__icon {
      width: 20px !important;
    }
  }
  
  .date-separator {
    flex-shrink: 0;
    color: #909399;
    padding: 0 1px;
    font-size: 12px;
  }
}

</style>